import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";

const ModalCategoria = ({ show, onHide, onSave, categoria }) => {
    const [nombre, setNombre] = useState("");
    const [ id, setId ] = useState(0);

    useEffect(() => {
        if (categoria) {
            setNombre(categoria.nombre);
            setId(categoria.id)
        } else {
            setNombre("");
            setId(0)
        }
    }, [categoria]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({ id, nombre });
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header
                closeButton
                style={{
                    background: "linear-gradient(90deg,#ff9ccf,#d63384)",
                    color: "white"
                }}
            >
                <Modal.Title>
                    {categoria ? "✏️ Editar Categoría" : "➕ Agregar Categoría"}
                </Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Nombre de la categoría</Form.Label>
                        <Form.Control
                            type="text"
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                            required
                        />
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        style={{
                            background: "#d63384",
                            border: "none"
                        }}
                    >
                        { categoria ? 'Editar' : 'Guardar' }
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ModalCategoria;